.root {
  display: contents;
}

.image {
  display: block;
  width: 100%;
  height: auto;
}
